<template>
    <div>

        <div v-if="passwordUpdated" class="reg-text-notice">
            Пароль успешно обновлен. Теперь можно войти в  систему с новым паролем.
            <div style="text-align: right">
                <router-link to="/login"><v-btn flat color="primary">Войти</v-btn></router-link>
            </div>
        </div>

        <form v-else class="main-page" @submit.prevent="sendData">

            <div class="main-page-nav">
                <div class="link active">Восстановление пароля</div>
            </div>

            <material-input v-model="email" :error="errors.email" type="text">E-mail</material-input>

            <material-input v-model="password" :error="errors.password" type="password">Пароль</material-input>

            <material-input v-model="password2" type="password">Пароль еще раз</material-input>

            <div style="text-align: center">
                <button type="submit">Сохранить пароль</button>
            </div>

        </form>

    </div>
</template>


<script>
    import axios from 'axios'
    import _ from 'lodash'
    import materialInput from '../../elements/material-input'

    export  default {
        components: {
            materialInput
        },
        data(){
            return {
                valid: true,
                errors:{
                  email: '',
                  password: '',
                },
                email: '',
                password: '',
                password2: '',
                passwordUpdated: false,
            }
        },
        methods: {
            sendData(){
                axios.post('/password/reset',{
                    token: this.$route.params.token,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password2,
                }).then((req)=>{
                    if(req.data.done){
                        this.passwordUpdated = true;
                        this.$store.dispatch('getAuthUser');
                    }
                }).catch((req)=>{
                    let data = req.response.data;
                    if(data.errors){
                        _.forEach(this.errors, (v, k)=>{
                            this.errors[k] = data.errors[k] ? data.errors[k].join('\n') : '';
                        })
                    }
                })
            }
        }
    }
</script>
